import _ from 'lodash';
import { orderBy } from '@skyjs/lodash-extras';
import Collection from '@skyjs/collection';

export default function filter(items, query) {
  const { first, offset, begin, orderBy: orderByClause, criteria } = query;

  if (!(items instanceof Collection)) {
    items = Collection.from(items);
  }

  if (!_.isEmpty(criteria)) {
    items = items.filter(criteria);
  }

  if (orderByClause) {
    items = orderBy(items, orderByClause, { mongoDbCompatible: true });
  }

  if (begin) {
    items = _.dropWhile(items, item => item.id !== begin);
  } else if (offset) {
    items = _.drop(items, offset);
  }

  if (first) {
    items = _.take(items, first);
  }

  return Collection.fromArray(items);
}
